import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref, watch, reactive } from "vue";
import DocsServices from "../../services/DocsServices";
import { ElMessage } from "element-plus";
import { useStore } from "@/store";
import i18n from "@/core/plugins/i18n";
import type { FormInstance } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'AddDocuments',
  emits: ["submitted"],
  setup(__props, { expose: __expose, emit: emits }) {

const t = i18n.global.t;
const store = useStore();
const user = store.state.AuthModule.user;
const site = ref(user.tenancy == "au" ? "ba" : user.tenancy);
const dialogRef = ref(false);
const isLoading = ref(false);

const operatorInfo = ref<any>({
  name: user.nativeName,
  email: user.email,
  updatedAt: new Date().toISOString(),
});
const formData = ref<any>({
  title: "",
  link: "",
  comment: "",
  site: site.value,
  operator_info: operatorInfo.value,
});

const ruleFormRef = ref<FormInstance>();
const rules = reactive<any>({
  title: [
    { required: true, message: "Please input document name", trigger: "blur" },
  ],
});

const show = () => {
  dialogRef.value = true;
};

const hide = () => {
  dialogRef.value = false;
};

const submit = async () => {
  if (!ruleFormRef.value) return;
  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;
  isLoading.value = true;

  try {
    await DocsServices.addNewDocument(formData.value);
    ElMessage.success("Documents Created Successfully");
    emits("submitted");
    hide();
  } catch (error) {
    ElMessage.error("Failed to create document");
  }
  isLoading.value = false;
};

watch(
  () => formData.value.title,
  (newTitle) => {
    formData.value.link = newTitle.trim().replace(/\s/g, "-").toLowerCase();
  }
);

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('fields.createNewDocument'),
    width: "900",
    "align-center": "",
    "before-close": hide
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: submit,
          loading: isLoading.value,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.upload")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        rules: rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.documentName'),
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.title) = $event)),
                clearable: "",
                disabled: isLoading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.documentUrl')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.link,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.link) = $event)),
                clearable: "",
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.comment')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.comment,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.comment) = $event)),
                clearable: "",
                disabled: isLoading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})